import React from 'react';
import 'flatpickr/dist/themes/material_green.css'
import { Col, Row, Form, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import 'react-bootstrap-multiselect/css/bootstrap-multiselect.css'
import './Filter.css';
import './react-datetime.css';
const Filter = (props) => {
  const { userId, bankAccount, currencyName } = props.criteria;

  return (
    <React.Fragment>
      <Row>
        <Col sm={2} className="pr-0">
          <Form.Group controlId="bankAccount">
            <Form.Label className="text-grey font-weight-bold medium">Account Number</Form.Label>
            <Form.Control type="text" name="bankAccount" value={bankAccount} onChange={props.onChange} placeholder="Account Number" />
          </Form.Group>
        </Col>
        <Col sm={2} className="pr-0">
          <Form.Group controlId="userId">
            <Form.Label className="text-grey font-weight-bold medium">User ID</Form.Label>
            <Form.Control type="text" name="userId" value={userId} onChange={props.onChange} placeholder="User ID" />
          </Form.Group>
        </Col>
        <Col sm={1.5} className="pr-0 pl-2">
          <Form.Group controlId="currencyName">
            <Form.Label className="text-grey font-weight-bold medium">Account Currency</Form.Label>
            <Form.Control as="select"
              name="currencyName"
              value={currencyName}
              onChange={props.onChange}>
              <option value="">All</option>
              <option value='FCD'>FCD</option>
              <option value='THB'>THB</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col sm={2} className="pr-0 pl-0 pt-1 mt-4">
          <Button type="button" variant="link" className="link" onClick={props.onSubmit}>
            <FontAwesomeIcon size="lg" icon={faSearch} />
          </Button>
          <Button type="button" variant="link" className="link" onClick={props.onReset}>
            <FontAwesomeIcon size="lg" icon={faUndoAlt} />
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  );
}
export default Filter;